export default {"src":"/_next/static/media/stopwatch_64.cc859768.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};